import { post } from "services/httpService";
import { makeQueryParams } from "utils";
import { ORGANIZATION_ID } from "utils/constants";
import { getDencrypted } from "utils/security";

const SERVICE_URLS = {
  signin: () => "user/signin/",
  signup: (qs) => `user/signup/?${qs}`,
  googleAuth: (qs) => `user/google_auth/?${qs}`,
  verifySignupEmail: () => `user/verify-account/`,
  resendEmailLink: () => `user/verify-email/`,
  forgotPassword: () => "user/forgot-password/",
  resetPassword: (qs) => `user/reset-password/?${qs}`,
  verifyPhone: () => `user/verify/`,
  saveQuestionnaire: () => `survey/`,
  getCaptcha: () => `captcha/`,
};

const getOrganizationHeaderConfig = () =>
  ORGANIZATION_ID
    ? { headers: { "x-organization-id": ORGANIZATION_ID } }
    : undefined;

export const saveQuestionnaire = (payload) =>
  post(SERVICE_URLS.saveQuestionnaire(), payload);

const getAllQueryParams = (data) => {
  let qs = {};

  if (data.referral_code) qs.referral_code = data.referral_code;
  if (data.origin) qs.origin = data.origin;
  if (data.discountCode) qs.discount_code = data.discountCode;
  if (data.plan) qs.plan = data.plan;
  if (data.utmSource) qs.utm_source = data.utmSource;
  if (data.utmMedium) qs.utm_medium = data.utmMedium;
  if (data.utmCampaign) qs.utm_campaign = data.utmCampaign;
  if (data.utmTerm) qs.utm_term = data.utmTerm;
  if (data.utmContent) qs.utm_content = data.utmContent;

  return makeQueryParams(qs);
};

export const signin = (data) => {
  const payload = {
    email: data.email.toLowerCase(),
    password: data.password,
  };
  return post(SERVICE_URLS.signin(), payload, getOrganizationHeaderConfig());
};

export const signup = (data) => {
  const queryParams = getAllQueryParams(data);

  const payload = {
    email: data.email.toLowerCase(),
    phone: data.phone && data.phone.length > 4 ? `+${data.phone}` : "",
    first_name: data.first_name,
    last_name: data.last_name,
    password: data.password,
    tracking_id: data.tracking_id,
    captcha_key: data.captcha_key,
    captcha_value: data.captcha_value,
  };

  return post(SERVICE_URLS.signup(queryParams), payload);
};

export const verifySignupEmail = (payload) =>
  post(SERVICE_URLS.verifySignupEmail(), payload);

export const resendEmailLink = (userEmail) => {
  const payload = {
    email: userEmail,
  };

  return post(SERVICE_URLS.resendEmailLink(), payload);
};

export const forgotPassword = (userEmail) => {
  const payload = {
    email: userEmail,
  };
  return post(
    SERVICE_URLS.forgotPassword(),
    payload,
    getOrganizationHeaderConfig()
  );
};

export const resetPassword = (data) => {
  const payload = {
    password: data.password,
  };

  const qs = makeQueryParams({
    token: data.token,
    uid: data.uid,
  });
  return post(
    SERVICE_URLS.resetPassword(qs),
    payload,
    getOrganizationHeaderConfig()
  );
};

export const verifyPhone = (data) => {
  const payload = {
    mfa_code: data.code,
    email: data.authUser?.email,
    password: getDencrypted(data.authUser?.password),
  };
  return post(SERVICE_URLS.verifyPhone(), payload);
};

export const googleAuth = (data) => {
  const queryParams = getAllQueryParams(data);

  const payload = {
    code: data.code,
    tracking_id: data.tracking_id,
  };
  return post(SERVICE_URLS.googleAuth(queryParams), payload);
};

export const getCaptcha = () => post(SERVICE_URLS.getCaptcha(), {});
